export default __webpack_public_path__ + "static/media/Children.66c90a10.webp";